module.exports = __webpack_public_path__ + "static/media/iconSectionPedagogie.94016d69.svg";